import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Cookies from "js-cookie";
import enTranslation from "./translate/en.json";
import trTranslation from "./translate/tr.json";
import frTranslation from "./translate/fr.json";

const resources = {
  en: { translation: enTranslation },
  tr: { translation: trTranslation },
  fr: { translation: frTranslation },
};

// Get language from cookies, or fallback to English
const savedLanguage = Cookies.get("lang") || "en";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage, // Set language from cookies
    fallbackLng: "en", // Fallback if language not found
    debug: false,
    detection: {
      order: ["cookie", "localStorage", "navigator"],
      caches: ["cookie"],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
